import React from 'react'
import styles from './ActionLink.scss'
import cx from 'classnames'

export const ActionLink = ({ className, active, disabled, children, ...props }) => {
  const cn = cx(styles.ActionLink, className, active && styles.active, disabled && styles.disabled)
  return (
    <a {...props} className={cn}>
      {children}
    </a>
  )
}
